import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment, TextFieldProps } from '@mui/material';
import { useState } from 'react';
import { MHMIconButton } from './MHMIconButton';
import { MHMTextField } from './MHMTextField';

export type MHMPasswordFieldProps = TextFieldProps;

export function MHMPasswordField(props: MHMPasswordFieldProps) {
  const { type, ...rest } = props;
  const [show, setShow] = useState(false);

  return (
    <MHMTextField
      {...rest}
      type={show ? 'text' : 'password'}
      slotProps={{
        formHelperText: { sx: { fontSize: 'inherit' } },
        input: {
          sx: { bgcolor: 'background.paper' },
          endAdornment: (
            <InputAdornment position="end">
              <MHMIconButton onClick={() => setShow(s => !s)} edge="end">
                {show ? <Visibility /> : <VisibilityOff />}
              </MHMIconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
